import React from "react";

export type OpportunityTab = "all" | "event";

type OpportunityTypeToggleProps = {
  activeTab: OpportunityTab;
  onChange: (tab: OpportunityTab) => void;
  labels: Record<OpportunityTab, string>;
};

const TABS: OpportunityTab[] = ["all", "event"];

// Segmented control used to switch between all and event opportunities.
const OpportunityTypeToggle: React.FC<OpportunityTypeToggleProps> = ({
  activeTab,
  onChange,
  labels,
}) => (
  <div className="inline-flex rounded-full bg-[#F4F4F5] p-1 mb-4 sm:mb-6">
    {TABS.map((tab) => (
      <button
        key={tab}
        type="button"
        onClick={() => onChange(tab)}
        className={`rounded-full px-4 py-1.5 text-xs sm:text-sm font-semibold transition-colors whitespace-nowrap ${
          activeTab === tab
            ? "bg-white text-[#11181C] shadow-sm"
            : "text-[#71717A] hover:text-[#11181C]"
        }`}
      >
        {labels[tab]}
      </button>
    ))}
  </div>
);

export default OpportunityTypeToggle;
